import { DiTypes } from "@di/builder/di-types";

export const coreTypes = Object.seal({
    infrastructure: {
        Http: Symbol.for("Http"),
    },
} satisfies DiTypes);
